import { React, Text } from "mondrian-react";
import { useEffect, useState } from "react";
import { logger } from "utils/logger";
import "./style.scss";
import { reportGA4 } from "utils/pushDataLayer";

export function Dialog({ title, description, isOpen, onClick, botao }) {
  const [open, setOpen] = useState(isOpen);

  const formataNomeBotaoGA = (nome) => {
    const semCaracteresEspeciais = nome.replace(/[^\w\s]/gi, '');
    const comUnderscores = semCaracteresEspeciais.replace(/\s+/g, '_');
    const emMinusculas = comUnderscores.toLowerCase();
    return emMinusculas;
  }

  const reportGA4BotaoModal = (botao) => {
    const nomeBotao = !!botao ? formataNomeBotaoGA(botao) : 'tentar_novamente'
    reportGA4({customTitle: `codigo_de_seguranca:${nomeBotao}`})
  }

  useEffect(() => {
    if (isOpen) {
      setOpen("mdn-Modal mdn-Modal--sm mdn-isOpen");
    } else {
      setOpen("mdn-Modal mdn-Modal--sm");
    }
  }, [isOpen]);

  function handleModalClose() {
    setOpen("mdn-Modal mdn-Modal--sm");
  }

  function handleModalCloseRefresh() {
    window.location.reload();
  }

  return (
    <div>
      {open.length > 1 ? (
        <div className={open ?? "mdn-Modal mdn-Modal--sm"}>
          <div className="mdn-Modal-content">
            <div className="mdn-Modal-header">
              <h1 className="mdn-Heading mdn-Heading--md">{title}</h1>
              <button
                onClick={handleModalCloseRefresh}
                className="mdn-Button-header-close mdn-Button mdn-Button--icon mdn-Button--secondary"
                aria-label="Close modal"
              >
                <i className="mdn-Icon-fechar mdn-Icon--sm"></i>
              </button>
            </div>
            <div className="mdn-Divider mdn-Divider--default"></div>
            <div className="mdn-Modal-body">
              {" "}
              {Array.isArray(description) ? 
                <Text body className="textModalDescription">
                  {description.map((op) => op)}
                </Text>
                : description
              }
            </div>
            <div className="mdn-Modal-footer">
              <div className="mdn-Modal-footer-end">
                <button
                  onClick={() => {
                    handleModalClose();
                    logger({ name: botao ? "Botao" : "TentarNovamente" });
                    reportGA4BotaoModal(botao)
                    onClick();
                  }}
                  className="mdn-Button mdn-Button--primary buttonMin"
                >
                  {botao ? botao : "Tentar Novamente"}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
